module.exports = __webpack_public_path__ + "media/customizations/trillium/logo-617ebb5775d8a02df661d088e634cc33.png";